import React, { useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import {
    TextField,
    Card,
    Breadcrumbs,
    Link,
    Typography,
    CardContent,
    Container,
    Grid,
    Backdrop,
    CircularProgress,
    Button,
    Snackbar,
    ThemeProvider,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    BottomNavigation,
    BottomNavigationAction
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import { getUser } from 'src/utils/Common';
import Alert from 'src/components/Alert';
import trLocale from 'date-fns/locale/tr';
import { createMuiTheme } from '@material-ui/core/styles';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
    getTasksRequest
} from '../../store/actions';
import SearchBar from 'material-ui-search-bar';
import { workOrderCargoActions, workOrderCargoThunks } from '../../store/slices/workOrderCargoSlice'
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionActions from '@material-ui/core/AccordionActions';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import BusinessIcon from '@material-ui/icons/Business';

const localeMap = {
    tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');

const siyah = '#424242';


const materialTheme = createMuiTheme({
    palette: {
        primary: {
            contrastText: '#FFFFFF',
            dark: siyah,
            main: siyah,
            light: siyah
        }
    }
});


const useStyles = makeStyles(theme => ({
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
    },
    root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    cardscontent: {
        minHeight: 300
    },
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    tableRow: {
        '&$hover:hover': {
            backgroundColor: '#E4DCCF'
        }
    },
    tableCell: {
        '$hover:hover &': {
            color: 'black'
        }
    },
    hover: {},
    searchB: {
        flexGrow: 1,
        height: 42,
        padding: theme.spacing(0, 2),
        display: 'flex',
        alignItems: 'center'
    },
    searchIconB: {
        marginRight: theme.spacing(0),
        color: theme.palette.icon
    },
    searchInputB: {
        flexGrow: 1
    },
    searchButtonB: {
        backgroundColor: theme.palette.common.white,
        marginLeft: theme.spacing(2)
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    warning: {
        fontSize: theme.typography.pxToRem(13),
        color: theme.palette.warning.main,
        fontWeight: theme.typography.fontWeightMedium,
    },
    icon: {
        verticalAlign: 'bottom',
        height: 20,
        width: 20,
    },
    details: {
        alignItems: 'center',
    },
    column: {
        flexBasis: '33.33%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    }
}));


function WorkOrderCargoScreen() {

    const classes = useStyles();
    const { t } = useTranslation('overview');
    const SessionUser = getUser();
    const dispatch = useDispatch();

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [AlertType, setAlertType] = React.useState();
    const [WorkOrderHaveCargoRecord, setWorkOrderHaveCargoRecord] = React.useState(false)
    const [WorkOrderSearched, setWorkOrderSearched] = React.useState(false)
    const [Loading, setLoading] = useState(false);
    const [ResponseDsc, setResponseDsc] = useState('');
    const [WorkOrderFound, setWorkOrderFound] = useState(false)
    const [menuSelectionValue, setMenuSelectionValue] = useState(0)

    const searched = useSelector((state) => state.workOrderCargo.searched)
    const workOrderCargo = useSelector((state) => state.workOrderCargo.workOrderCargo)
    const cargoCompanies = useSelector((state) => state.workOrderCargo.cargoCompanies)
    const selectedCargoCompany = useSelector((state) => state.workOrderCargo.selectedCargoCompany)
    const selectedCargoNo = useSelector((state) => state.workOrderCargo.selectedCargoNo)
    const selectedDispatchDate = useSelector((state) => state.workOrderCargo.selectedDispatchDate)
    const selectedReturnCargoNo = useSelector((state) => state.workOrderCargo.selectedReturnCargoNo)
    const selectedOutDispatchDate = useSelector((state) => state.workOrderCargo.selectedOutDispatchDate)
    const selectedOutCargoCompany = useSelector((state) => state.workOrderCargo.selectedOutCargoCompany)

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackbar(false);
    };

    useEffect(() => {
        loadCargoCompanies()
    }, []);

    const loadCargoCompanies = () => {
        setLoading(true);
        dispatch(workOrderCargoThunks.GetCargoCompanies())
            .then((response) => {
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const requestSearch = (searchValue) => {
        setLoading(true);
        dispatch(workOrderCargoThunks.GetWorkOrderCargo(({ workOrderId: searchValue })))
            .then((response) => {
                if (response?.payload?.Code !== '400') {
                    setResponseDsc(response?.payload?.Message);
                    setAlertType('error');
                    setOpenSnackbar(true)
                    setWorkOrderSearched(false)
                    setWorkOrderFound(false)
                    dispatch(workOrderCargoActions.setSelectedCargoCompany(null))
                    dispatch(workOrderCargoActions.setselectedCargoNo(''))
                    dispatch(workOrderCargoActions.setSelectedDispatchDate(null))
                    dispatch(workOrderCargoActions.setSelectedReturnCargoNo(''));
                    dispatch(workOrderCargoActions.setSelectedOutCargoCompany(null))
                    dispatch(workOrderCargoActions.setSelectedOutDispatchDate(null))
                }
                else {
                    setWorkOrderHaveCargoRecord(response?.payload?.ResponseObject?.Id == 0 ? false : true)
                    setWorkOrderSearched(true)

                    if (response?.payload?.ResponseObject?.CargoCompanyId == null) {
                        dispatch(workOrderCargoActions.setSelectedCargoCompany(null))
                    }
                    else {
                        var cargoCompany = cargoCompanies.find(x => x.Id == response?.payload?.ResponseObject?.CargoCompanyId)
                        dispatch(workOrderCargoActions.setSelectedCargoCompany(cargoCompany))
                    }

                    if (response?.payload?.ResponseObject?.OutCargoCompanyId == null) {
                        dispatch(workOrderCargoActions.setSelectedOutCargoCompany(null))
                    }
                    else {
                        var cargoCompany = cargoCompanies.find(x => x.Id == response?.payload?.ResponseObject?.OutCargoCompanyId)
                        dispatch(workOrderCargoActions.setSelectedOutCargoCompany(cargoCompany))
                    }

                    dispatch(workOrderCargoActions.setselectedCargoNo(response?.payload?.ResponseObject?.CargoNo))
                    dispatch(workOrderCargoActions.setSelectedDispatchDate(response?.payload?.ResponseObject?.DispatchDate))
                    dispatch(workOrderCargoActions.setSelectedReturnCargoNo(response?.payload?.ResponseObject?.ReturnCargoNo || ''));
                    dispatch(workOrderCargoActions.setSelectedOutDispatchDate(response?.payload?.ResponseObject?.OutDispatchDate))

                    setWorkOrderFound(true)
                }

                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                setResponseDsc(error);
                setAlertType('error');
                setOpenSnackbar(true)
            });
    };

    const setWorkOrderCargo = () => {
        if (selectedCargoCompany == null || (selectedCargoNo == null || selectedCargoNo == '')) {
            setResponseDsc(t('lblWorkOrderCargoSaveError'));
            setAlertType('error');
            setOpenSnackbar(true)
        }

        let data = {
            workOrderId: workOrderCargo.ResponseObject.WorkOrderId,
            Id: workOrderCargo.ResponseObject.Id,
            cargoCompanyId: selectedCargoCompany.Id,
            cargoNo: selectedCargoNo,
            dispatchDate: selectedDispatchDate,
            returnCargoNo: selectedReturnCargoNo,
            outCargoCompanyId: selectedOutCargoCompany?.Id,
            outDispatchDate: selectedOutDispatchDate
        }

        dispatch(workOrderCargoThunks.SetWorkOrderCargo(data)).then(response => {
            if (response?.payload?.Code === '400') {
                setResponseDsc(t('lblWorkOrderCargoSaveSuccess'));
                setAlertType('success');
                setOpenSnackbar(true)
                requestSearch(searched)
            }
            else {
                setResponseDsc(response?.payload?.Message);
                setAlertType('error');
                setOpenSnackbar(true)
            }
        })
    }



    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={3} sm={3}>
                    <TextField
                        placeholder={t('lblWorkOrder')}
                        value={searched}
                        onChange={(event) => {
                            const searchVal = event.target.value.replace(/\D/g, '');
                            dispatch(workOrderCargoActions.setSearched(searchVal));
                        }}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                requestSearch(searched);
                            }
                        }}
                        fullWidth
                        variant="outlined"
                        inputProps={{
                            inputMode: 'numeric',
                            pattern: '[0-9]*'
                        }}
                    />
                </Grid>
            </Grid>

            {
                WorkOrderFound == true ?
                    <>
                        <Accordion expanded={true}>
                            <AccordionSummary
                                aria-controls="panel1c-content"
                                id="panel1c-header"
                            >
                                <div className={classes.column}>
                                    <Typography className={classes.heading}>{t('lblWorkOrderId') + ': ' + workOrderCargo?.ResponseObject?.WorkOrderId}</Typography>
                                </div>

                                {
                                    WorkOrderHaveCargoRecord == false && WorkOrderSearched == true ?
                                        <>
                                            <div className={classes.column}>
                                                <Typography className={classes.warning}>{t('lblNoCargoRecordForWorkOrder')}</Typography>
                                            </div>
                                        </>
                                        :
                                        <>
                                        </>
                                }
                            </AccordionSummary>
                            <AccordionDetails className={classes.details}>
                                <Grid container spacing={1} alignItems="center">
                                    {/* <Chip label="Barbados" onDelete={() => { }} /> */}
                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '8px' }}>
                                        <Typography variant="caption">
                                            {t('lblWorkOrderCargoId') + ': '}
                                            <br />
                                            <a className={classes.link}>
                                                {workOrderCargo?.ResponseObject?.Id}
                                            </a>
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3} sm={3} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '8px' }}>
                                        <Divider orientation="vertical" flexItem style={{ height: '15vh', alignSelf: 'stretch', marginLeft: '5vh' }} />
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', width: '100%' }}> {/* Increased gap and width */}
                                            <Autocomplete
                                                size="medium"
                                                fullWidth
                                                autoSelect
                                                options={cargoCompanies || []}
                                                getOptionLabel={option => (option ? option.Name : '')}
                                                value={selectedCargoCompany || null}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label={t('lblCargoCompany')}
                                                        variant="outlined"
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                minWidth: '30vh', // Increased width
                                                                minHeight: '5vh',
                                                                maxHeight: '5vh'
                                                            }
                                                        }}
                                                    />
                                                )}
                                                onChange={(event, value) => {
                                                    dispatch(workOrderCargoActions.setSelectedCargoCompany(value));
                                                }}
                                            />
                                            <Autocomplete
                                                size="medium"
                                                fullWidth
                                                autoSelect
                                                options={cargoCompanies || []}
                                                getOptionLabel={option => (option ? option.Name : '')}
                                                value={selectedOutCargoCompany || null}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        label={t('lblOutCargoCompany')}
                                                        variant="outlined"
                                                        sx={{
                                                            '& .MuiOutlinedInput-root': {
                                                                minWidth: '30vh', // Increased width
                                                                minHeight: '5vh',
                                                                maxHeight: '5vh'
                                                            }
                                                        }}
                                                    />
                                                )}
                                                onChange={(event, value) => {
                                                    dispatch(workOrderCargoActions.setSelectedOutCargoCompany(value));
                                                }}
                                            />
                                        </div>
                                    </Grid>

                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '8px' }}>
                                        <Divider orientation="vertical" flexItem style={{ height: '15vh', alignSelf: 'stretch', marginLeft: '5vh' }} />
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <Typography variant="caption">
                                                {t('lblCargoNo') + ': '}
                                                <br />
                                                <TextField
                                                    size="small"
                                                    id="orderNumber"
                                                    autoComplete="no"
                                                    value={selectedCargoNo}
                                                    onChange={event =>
                                                        dispatch(workOrderCargoActions.setselectedCargoNo(event.target.value))
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            minWidth: '15vh',
                                                            minHeight: '5vh',
                                                            maxHeight: '5vh'
                                                        }
                                                    }}
                                                />
                                            </Typography>
                                            <Typography variant="caption">
                                                {t('lblReturnCargoNo') + ': '}
                                                <br />
                                                <TextField
                                                    size="small"
                                                    id="returnCargoNumber"
                                                    autoComplete="no"
                                                    value={selectedReturnCargoNo}
                                                    onChange={event => dispatch(workOrderCargoActions.setSelectedReturnCargoNo(event.target.value))}
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            minWidth: '15vh',
                                                            minHeight: '5vh',
                                                            maxHeight: '5vh'
                                                        }
                                                    }}
                                                />
                                            </Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={3} sm={3} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '8px' }}>
                                        <Divider orientation="vertical" flexItem style={{ height: '15vh', alignSelf: 'stretch', marginLeft: '5vh' }} />
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <ThemeProvider theme={materialTheme}>
                                                <MuiPickersUtilsProvider
                                                    utils={DateFnsUtils}
                                                    locale={localeMap[locale]}
                                                >
                                                    <KeyboardDatePicker
                                                        color="primary"
                                                        inputVariant="outlined"
                                                        id="orderDate"
                                                        size="small"
                                                        invalidDateMessage={t('hatali_tarih')}
                                                        format="dd-MM-yyyy"
                                                        fullWidth
                                                        label={t('lblDispatchDate')}
                                                        variant="outlined"
                                                        value={selectedDispatchDate}
                                                        onChange={e => {
                                                            dispatch(workOrderCargoActions.setSelectedDispatchDate(e))
                                                        }
                                                        }
                                                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </ThemeProvider>
                                            <ThemeProvider theme={materialTheme}>
                                                <MuiPickersUtilsProvider
                                                    utils={DateFnsUtils}
                                                    locale={localeMap[locale]}
                                                >
                                                    <KeyboardDatePicker
                                                        color="primary"
                                                        inputVariant="outlined"
                                                        id="orderDate"
                                                        size="small"
                                                        invalidDateMessage={t('hatali_tarih')}
                                                        format="dd-MM-yyyy"
                                                        fullWidth
                                                        label={t('lblOutDispatchDate')}
                                                        variant="outlined"
                                                        value={selectedOutDispatchDate}
                                                        onChange={e => {
                                                            dispatch(workOrderCargoActions.setSelectedOutDispatchDate(e))
                                                        }
                                                        }
                                                        KeyboardButtonProps={{ 'aria-label': 'change date' }}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </ThemeProvider>
                                        </div>

                                    </Grid>
                                    <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: '8px' }}>
                                        <Divider orientation="vertical" flexItem style={{ height: '15vh', alignSelf: 'stretch', marginLeft: '5vh' }} />
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                            <Typography variant="caption">
                                                {t('lblCreateDate') + ': '}
                                                <br />
                                                <a className={classes.link}>
                                                    {moment(workOrderCargo?.ResponseObject?.CreateDate).format('DD-MM-YYYY hh:mm')}
                                                </a>
                                            </Typography>

                                            <Typography variant="caption">
                                                {t('lblUpdateDate') + ': '}
                                                <br />
                                                <a className={classes.link}>
                                                    {moment(workOrderCargo?.ResponseObject?.UpdateDate).format('DD-MM-YYYY hh:mm')}
                                                </a>
                                            </Typography>
                                        </div>

                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                            <AccordionActions>
                                <Button
                                    size="small"
                                    color="secondary"
                                    onClick={() => setWorkOrderCargo()}
                                >
                                    {WorkOrderHaveCargoRecord == false ? t('lblSave') : t('lblUpdate')}
                                </Button>
                            </AccordionActions>
                        </Accordion>
                    </>
                    :
                    <>
                    </>
            }
        </>
    )
}



export default WorkOrderCargoScreen;